// import BandaPromociones from "components/BandaPromociones";
import portada from "../../assets/img/1927.jpg"
import Noticias from "./noticias";
import Masleido from "./masleido";
// import { FaArrowRight } from "react-icons/fa";
import Categorias from "./categorias";
import { urlBack } from "utils/urlEnpoint";
import React, { useState, useRef, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import observador from "../../assets/img/observador.png"
import imagen_1_video from "../../assets/img/imagen_video_1.jpeg"
import imagen_2_video from "../../assets/img/imagen_video_2.jpeg"

// const recibirData = async (url) => {
//   try {
//     const resp = await fetch(url, {
//       method: "GET",
//       // body: JSON.stringify(data),
//       headers: {
//         "Content-Type": "application/json",
//         // "Authorization": `Bearer ${token}`
//       },
//       mode: "cors",
//     });

//     if (!resp.ok) {
//       const errorText = await resp.text();
//       throw new Error(`Error en la respuesta del servidor: ${resp.status} ${errorText}`);
//     }

//     return await resp.json();
//   } catch (error) {
//     console.error("Error al enviar los datos:", error);
//     return { error: error.message };
//   }
// };


const EnviarData = async (url, data) => {
  try {
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        // "Authorization": `Bearer ${token}`
      },
      mode: "cors",
    });

    if (!resp.ok) {
      const errorText = await resp.text();
      throw new Error(`Error en la respuesta del servidor: ${resp.status} ${errorText}`);
    }

    return await resp.json();
  } catch (error) {
    console.error("Error al enviar los datos:", error);
    return { error: error.message };
  }
};

const AutoCompleteSearch = ({ noticias }) => {

  const navigate = useNavigate()
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  // const [searchResults, setSearchResults] = useState([]);
  const searchRef = useRef(null);

  // Cerrar sugerencias al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Actualizar sugerencias y resultados en tiempo real
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setSuggestions([]);
      // setSearchResults([]);
      return;
    }
    
    // Generar sugerencias
    const filteredSuggestions = noticias.filter(noticia => 
      noticia.titulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      noticia.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      noticia.tipo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      noticia.titular.toLowerCase().includes(searchTerm.toLowerCase())
    ).slice(0, 5);
    
    setSuggestions(filteredSuggestions);
    
    // Generar resultados completos
    // const results = noticias.filter(noticia => 
    //   noticia.titulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   noticia.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   noticia.tipo.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   noticia.titular.toLowerCase().includes(searchTerm.toLowerCase())
    // );
    
    // setSearchResults(results);
  }, [searchTerm, noticias]);

  const handleSelectSuggestion = (titulo,id) => {
    setSearchTerm(titulo);
    setShowSuggestions(false);
    postPublicaciones(id)
  };
   const postPublicaciones = async (id) => {
    const data = {
      id
    }
    const respJson = await EnviarData(`${urlBack}publicaciones.php`, data);

    // console.log(respJson, "res")
    if (respJson.success === 'Click registrado correctamente') {

      navigate(`/publicacion/${id}`)
      // console.log("navegar")
    }

  }

  return (
    <div className="search-container">
      <div ref={searchRef} className="search-input-container">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => setShowSuggestions(true)}
          placeholder="Buscar noticias..."
          className="search-input"
          autoComplete="off"
        />
        
        {showSuggestions && suggestions.length > 0 && (
          <ul className="suggestions-list">
            {suggestions.map((item) => (
              <li 
                key={item.id} 
                onClick={() => handleSelectSuggestion(item.titulo,item.id)}
                className="suggestion-item "
                
              >
                {item.titulo}
              </li>
            ))}
          </ul>
        )}

      </div>

      {/* Mostrar resultados de búsqueda */}
      {/* <div className="search-results">
        {searchResults.map(noticia => (
          <div key={noticia.id} className="noticia-card">
            <h3>{noticia.titulo}</h3>
            <p className="noticia-tipo">{noticia.tipo}</p>
            <p className="noticia-descripcion">{noticia.description.slice(0, 150)}...</p>
            <div className="noticia-footer">
              <span>{noticia.titular}</span>
              <span>{noticia.fecha}</span>
            </div>
          </div>
        ))}
      </div> */}
    </div>
  );
};

// const VideoRow = () => {
//   return (
//     <div className="video-section">
//       <h2 className="section-title">Nuestros Videos Destacados</h2>
      
//       <div className="video-row">
//         {/* Primer Video */}
//         <div className="video-container">
//           <div className="video-wrapper">
//             <video controls className="video-player">
//               <source src="http://laverdadminera.mx/back/videos/video1.mp4" type="video/mp4" />
//               Tu navegador no soporta videos HTML5.
//             </video>
//           </div>
//           <div className="video-info">
//             <h3 className="text-between text-bold">Si la ley de mineria avanza</h3>
//             {/* <p className="video-description">Descripción breve del primer video que explica su contenido</p> */}
//           </div>
//         </div>

//         {/* Segundo Video */}
//         <div className="video-container">
//           <div className="video-wrapper">
//             <video controls className="video-player">
//               <source src="http://laverdadminera.mx/back/videos/video2.mp4" type="video/mp4" />
//               Tu navegador no soporta videos HTML5.
//             </video>
//           </div>
//           <div className="video-info">
//             <h3 className="text-between text-bold">Una industria esencial</h3>
//             {/* <p className="video-description">Descripción breve del segundo video que explica su contenido</p> */}
//           </div>
//         </div>
//       </div>

//       {/* Estilos */}
//       <style jsx>{`
//         .video-section {
//           max-width: 1200px;
//           margin: 50px auto;
//           padding: 0 20px;
//         }
        
//         .section-title {
//           text-align: center;
//           margin-bottom: 40px;
//           color: #2d3748;
//           font-size: 2rem;
//         }
        
//         .video-row {
//           display: flex;
//           justify-content: space-between;
//           gap: 30px;
//         }
        
//         .video-container {
//           flex: 1;
//           background: white;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 5px 15px rgba(0,0,0,0.1);
//           transition: transform 0.3s ease;
//         }
        
//         .video-container:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 8px 25px rgba(0,0,0,0.15);
//         }
        
//         .video-wrapper {
//           position: relative;
//           padding-top: 56.25%; /* Relación de aspecto 16:9 */
//           background: #000;
//         }
        
//         .video-player {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           border: none;
//         }
        
//         .video-info {
//           padding: 20px;
//         }
        
//         .video-title {
//           margin: 0 0 10px 0;
//           color: #2d3748;
//           font-size: 1.3rem;
//         }
        
//         .video-description {
//           color: #4a5568;
//           line-height: 1.5;
//           margin: 0;
//         }
        
//         /* Responsive */
//         @media (max-width: 768px) {
//           .video-row {
//             flex-direction: column;
//             gap: 40px;
//           }
          
//           .section-title {
//             font-size: 1.7rem;
//           }
//         }
        
//         @media (max-width: 480px) {
//           .video-info {
//             padding: 15px;
//           }
          
//           .video-title {
//             font-size: 1.2rem;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };
const VideoRow = () => {
  // Estados para controlar si cada video está reproduciéndose
  const [playing1, setPlaying1] = useState(false);
  const [playing2, setPlaying2] = useState(false);
  
  // Referencias a los elementos de video
  const videoRef1 = useRef(null);
  const videoRef2 = useRef(null);

  // Función para manejar la reproducción
  const handlePlay = (videoNumber) => {
    if (videoNumber === 1) {
      setPlaying1(true);
      videoRef1.current.play();
    } else {
      setPlaying2(true);
      videoRef2.current.play();
    }
  };

  return (
    <div className="video-section">
      <h2 className="section-title">Nuestros Videos Destacados</h2>
      
      <div className="video-row">
        {/* Primer Video */}
        <div className="video-container">
          <div className="video-wrapper">
            <video 
              ref={videoRef1}
              controls 
              className="video-player"
              onPlay={() => setPlaying1(true)}
            >
              <source src="https://laverdadminera.mx/back/videos/video1.mp4" type="video/mp4" />
              Tu navegador no soporta videos HTML5.
            </video>
            
            {/* Overlay con imagen de portada */}
            {!playing1 && (
              <div 
                className="video-overlay"
                onClick={() => handlePlay(1)}
              >
                <img 
                  src={imagen_1_video}
                  alt="Portada video 1" 
                  className="cover-image"
                />
                <div className="play-button">
                  <svg viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" fill="white"/>
                  </svg>
                </div>
              </div>
            )}
          </div>
          <div className="video-info">
            <h3 className="text-between text-bold">Si la ley de mineria avanza</h3>
          </div>
        </div>

        {/* Segundo Video */}
        <div className="video-container">
          <div className="video-wrapper">
            <video 
              ref={videoRef2}
              controls 
              className="video-player"
              onPlay={() => setPlaying2(true)}
            >
              <source src="https://laverdadminera.mx/back/videos/video2.mp4" type="video/mp4" />
              Tu navegador no soporta videos HTML5.
            </video>
            
            {/* Overlay con imagen de portada */}
            {!playing2 && (
              <div 
                className="video-overlay"
                onClick={() => handlePlay(2)}
              >
                <img 
                  src={imagen_2_video}
                  alt="Portada video 2" 
                  className="cover-image"
                />
                <div className="play-button">
                  <svg viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" fill="white"/>
                  </svg>
                </div>
              </div>
            )}
          </div>
          <div className="video-info">
            <h3 className="text-between text-bold">Una industria esencial</h3>
          </div>
        </div>
      </div>

      {/* Estilos */}
      <style jsx>{`
        .video-section {
          max-width: 1200px;
          margin: 50px auto;
          padding: 0 20px;
        }
        
        .section-title {
          text-align: center;
          margin-bottom: 40px;
          color: #2d3748;
          font-size: 2rem;
        }
        
        .video-row {
          display: flex;
          justify-content: space-between;
          gap: 30px;
        }
        
        .video-container {
          flex: 1;
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
          transition: transform 0.3s ease;
        }
        
        .video-container:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
        }
        
        .video-wrapper {
          position: relative;
          padding-top: 56.25%; /* Relación de aspecto 16:9 */
          background: #000;
        }
        
        .video-player {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: none;
        }
        
        .video-info {
          padding: 20px;
        }
        
        .video-title {
          margin: 0 0 10px 0;
          color: #2d3748;
          font-size: 1.3rem;
        }
        
        .video-description {
          color: #4a5568;
          line-height: 1.5;
          margin: 0;
        }
        
        /* Nuevos estilos para el overlay */
        .video-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
          z-index: 10;
        }
        
        .cover-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .play-button {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 70px;
          height: 70px;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }
        
        .play-button svg {
          width: 30px;
          height: 30px;
        }
        
        .video-overlay:hover .play-button {
          background: rgba(0, 0, 0, 0.9);
          transform: translate(-50%, -50%) scale(1.1);
        }
        
        /* Responsive */
        @media (max-width: 768px) {
          .video-row {
            flex-direction: column;
            gap: 40px;
          }
          
          .section-title {
            font-size: 1.7rem;
          }
          
          .play-button {
            width: 50px;
            height: 50px;
          }
        }
        
        @media (max-width: 480px) {
          .video-info {
            padding: 15px;
          }
          
          .video-title {
            font-size: 1.2rem;
          }
          
          .play-button {
            width: 40px;
            height: 40px;
          }
          
          .play-button svg {
            width: 20px;
            height: 20px;
          }
        }
      `}</style>
    </div>
  );
};



export default function Inicio() {

  const navigate = useNavigate()
  // const [publicaciones, setPublicaciones] = useState([])
  const [perspectivas, setPerspectivas] = useState([])
  const [impacto, setImpacto] = useState([])
  const [cotidiano, setCotidiano] = useState([])

  let noticiasPost = [
    {
      id: 1,
      titulo: "Reforma minera: cuando el desconocimiento paraliza un pilar de la economía",
      description: "Crítica a los diputados que aprobaron la reforma a la Ley Minero y que, gracias a su desconocimiento en la materia, paralizaron un pilar de la economía mexicana que solo el 2023 generó una riqueza de más de 269,000 millones de pesos. Este impasse frenó trámites y permisos y congeló una inversión estimada en 12,000 millones de dólares, capaces de fluir en sólo dos años. En un contexto internacional marcado por tensiones como la crisis arancelaria, dicha inversión representaría oxígeno puro para la economía mexicana y una señal de confianza para los mercados",
      tipo: "PERSPECTIVA ESTRATÉGICA",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
    {
      id: 2,
      titulo: "Sin minería no habrá un Plan México exitoso",
      description: "De los 9 sectores estratégicos que propone impulsar el Plan MX -la estrategia principal del gobierno para hacer frente a la guerra comercial iniciada por Donald Trump- por lo menos 5 dependen de la minería: farmacéutica, semiconductores, energía, automotriz y electromovilidad y aeroespacial. El Plan México habla de sustituir importaciones, pero si no se dinamiza el sector minero, México podría convertirse en importador de minerales. Por esto es importante no solo sacar al sector minero del limbo en el que lo metió la reforma a la Ley de Minería, sino también impulsarlo para potenciar el Plan México.",
      tipo: "PERSPECTIVA ESTRATÉGICA",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
    {
      id: 3,
      titulo: "Minería mexicana, rezagada frente a Chile o Perú por impasse de la reforma minera",
      description: "A diferencia de México, Chile y Perú esperan un año alcista en cuanto a producción e inversión en minería, lo cual se traduce en un beneficio económico para el PIB de ambos países en medio de una guerra comercial global. En cambio, en México el sector está paralizado, ha visto una disminución en las inversiones, el aumento de impuestos e incertidumbres regulatorias. Incluso, el sector minero podría ver una caída en las inversiones de más del 20% durante 2025, pasando de 5,000 mdd en 2024 a solo 3,000 este año. Hace falta destrabar el sector, dinamizarlo y ponerlo en marcha de nuevo, con o sin reforma minera.",
      tipo: "PERSPECTIVA ESTRATÉGICA",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
    {
      id: 4,
      titulo: "¿Por qué Olinia, el auto eléctrico de Sheinbaum, no será posible sin la minería?",
      description: "Microconductores, infraestructura, salud pública y bosques. ¿Qué sería de ellos sin minería? La relevancia del sector minero en el éxito de Olinia es fundamental. La producción de vehículos eléctricos requiere una variedad de minerales estratégicos como litio, cobre, grafito y tierras raras, esenciales para baterías, motores y componentes electrónicos. México, con su potencial geológico y capacidad de producción, puede proveer esta base material de manera competitiva y responsable. La minería nacional no sólo es compatible con Olinia; es una condición necesaria para su viabilidad y escalamiento.",
      tipo: "PERSPECTIVA ESTRATÉGICA",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
    {
      id: 5,
      titulo: "Cómo te cuentan la minería vs cómo en realidad es",
      description: "Contenido para contrastar las verdades a medias en contra de la minería, frente al estado actual de la industrial (la minería ya no es como la vimos en los 7 enanos, ha tenido una transformación tecnológica y ha adoptado prácticas sustentables). Sirve para posicionar datos relevantes de la industria.",
      tipo: "IMPACTO Y TRANSFORMACIÓN",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
    {
      id: 6,
      titulo: "10 mentiras",
      description: "“La minería ya no es necesaria en la era digital” “La minería sólo sirve para enriquecer a las grandes empresas” “México no tiene un papel relevante en la minería global” “La minería contamina porque quiere, no porque tenga que hacerlo” “La minería y el medio ambiente son enemigos naturales” “La minería ya no tiene nada que ver con el futuro” “Todos los proyectos mineros afectan comunidades indígenas” “La minería es incompatible con los derechos humanos” “La minería no paga impuestos” “La minería no puede cambiar”. En cada caso, se argumenta por que la afirmación es falsa.",
      tipo: "IMPACTO Y TRANSFORMACIÓN",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
    {
      id: 7,
      titulo: "Así sería un día sin minería en México",
      description: "Si durante 2023 el país hubiera paralizado su industria minera por un día, se habrían perdido 736.9 millones de dólares de riqueza; se habrían dejado de aportar a la Tesorería del país 134.2 millones de pesos. Casi medio millón de personas habrían dejado de percibir su salario; México habría perdido el primer lugar mundial en producción de plata y el décimo en producción de cobre, un mineral crítico para la economía global de las próximas décadas. Además, se habrían dejado de producir infraestructura como viviendas y hospitales, paneles solares, turbinas eólicas, baterías e incluso dispositivos médicos. ",
      tipo: "IMPACTO Y TRANSFORMACIÓN",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
    {
      id: 8,
      titulo: "¿Por qué la transición energética del gobierno de México depende de la minería?",
      description: "Gran parte de la demanda de minerales críticos ha sido impulsada por su rol en la transición hacia energías limpias y una economía baja en carbono, una de las prioridades del actual gobierno. El cobre, del que México es el productor número 10 a nivel global, es esencial para producir tecnologías de energía eólica o autos eléctricos. Se estima que un auto eléctrico requiere seis veces más minerales que uno convencional, mientras una planta de energía eólica requiere nueve veces más minerales que una de gas. ",
      tipo: "IMPACTO Y TRANSFORMACIÓN",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
    {
      id: 9,
      titulo: "La minería antes de la reforma VS La minería después de la reforma",
      description: "Cómo la reforma transforma las reglas del juego en un sector clave para la transición energética y el desarrollo económico de México. Compara el panorama del sector minero en México antes y después de la reforma a la Ley Minera, destacando los principales cambios en materia de regulación, participación del Estado, impacto ambiental y beneficios sociales. ",
      tipo: "IMPACTO Y TRANSFORMACIÓN",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
    {
      id: 10,
      titulo: "La importancia de la minería mexicana en números",
      description: "En medio de un contexto económico convulso, agitado por la guerra comercial de Trump, hay sectores con una presencia robusta en la economía mexicana como la minería, que pueden ayudar al país a dinamizar el mercado interno y fortalecer su posición en la contienda global.",
      tipo: "MINERÍA COTIDIANA",
      fecha: "20 de Mayo del 2025",
      titular: "El observador"
    },
  ]

  const getPublicaciones = async () => {
    // const respJson = await recibirData(`${urlBack}publicaciones.php`);

    // console.log(respJson, "res")
    let firstFillter = noticiasPost.filter((noticia) => {
      return noticia.tipo === "PERSPECTIVA ESTRATÉGICA"
    })
    
    let secondFillter = noticiasPost.filter((noticia) => {
      return noticia.tipo === "IMPACTO Y TRANSFORMACIÓN"
    })

    let thirdFillter = noticiasPost.filter((noticia) => {
      return noticia.tipo === "MINERÍA COTIDIANA"
    })
    setPerspectivas(firstFillter)
    setImpacto(secondFillter)
    setCotidiano(thirdFillter)
    // setPublicaciones(respJson.data)
  }

  const postPublicaciones = async (id) => {
    const data = {
      id
    }
    const respJson = await EnviarData(`${urlBack}publicaciones.php`, data);

    console.log(respJson, "res")
    if (respJson.success === 'Click registrado correctamente') {

      navigate(`/publicacion/${id}`)
      // console.log("navegar")
    }

  }



  useEffect(() => {
    let isMounted = true
    if (isMounted) {
      getPublicaciones()
    }

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line
  }, [])


  return (
    <>
      <div className=''>
        <div className="bg-banner" data-aos="flip-down">
          <div className="container">
            <div className="d-lg-flex justify-content-center align-items-center h-100">
              <div className="marginTop-60">
                <h1 className="text-big text-white text-center">La Verdad Minera</h1>
                <p className="text-medium text-white text-center">Explora el presente y el futuro de la minería con mirada crítica, datos claros y sin rodeos.</p>
                <AutoCompleteSearch noticias={noticiasPost} />
              </div>
              <div >
                <img className="minero-hide" src={observador} alt="El observador minero"/>
              </div>
            </div>
            

          </div>
        </div>
        <div className="">
            <VideoRow />
        </div>
        <div className="container" >
          <div className="d-lg-flex mt-5" >
            <h2 className="text-biggest text-bold text-blue w-50 w-responsive">REFORMA MINERA</h2>
            <div className="w-50 w-responsive mt-5">
              <p style={{ textAlign: 'justify' }}>En 2023, México cayó 37 lugares en el Índice de Atracción de Inversión en minería y no es casualidad, pues en el mismo año los legisladores aprobaron la reforma a la Ley Minera,  cuyo principal error fue dejar en manos del Servicio Geológico Mexicano (SGM) la exploración de nuevos proyectos. Y digo errores porque carece del presupuesto suficiente para realizar esa y otras tareas.</p>
              <div className="d-flex justify-content-end">
                <div className="cta-leerMas" onClick={() => {
                  postPublicaciones(1)
                }}>Leer Más</div>
              </div>
              <div className="d-flex align-items-center mt-5">
                <div className="text-small"><span className="text-bold">Texto: </span>El Observador Minero</div>
                <div className="text-small ms-3"><span className="text-bold">Fecha: </span>26 de mayo del 2025</div>
                <div className="col"></div>
                <div className="pildora">PERSPECTIVA ESTRATÉGICA</div>
              </div>
            </div>
          </div>

          <div className="w-100 " data-aos="zoom-in">
            <img className="w-100 paddingportada" src={portada} alt="portada" />
          </div>
          <div className="d-lg-flex" data-aos="zoom-in">
            <Noticias />
            <Masleido />
          </div>

          <div className="" data-aos="zoom-in">
            {/* <div className="text-blue mt-2">VER TODOS LOS ARTÍCULOS <span><FaArrowRight /></span></div> */}

            <div className="text-big text-bold text-blue borderTopBlue">CATEGORÍAS</div>
            <Categorias
              noPerspectivas={perspectivas.length}
              noImpacto={impacto.length}
              noCotidiano={cotidiano.length}
              reorden={(tipo) => {
                console.log(tipo)
              }}
            />
          </div>
        </div>


        {/* <img src={mantenimiento} alt="mantenimiento" /> */}
      </div>
    </>
  );
}
